import React, { Component } from 'react';
// import { Link } from 'react-router';
// import { orderBy } from 'lodash';
import moment from 'moment';
import LazyLoad from 'react-lazyload';
import Header from '../../components/Header';
import { onGoBack } from '../../common/globals';
import withGoBack from '../../common/withGoBack';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withOnline from '../../common/withOnline';
import withUser from '../../common/withUser';
import withTableName from '../../common/withTableName';
import { caseHistory } from '../../utils/utils';
import { getTableCaseByCaseId } from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
import ZeroProductSubmitModal from '../../components/Models/ZeroProductSubmitModal';
import withTeam from '../../common/withTeam';

class CaseHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {},
      filterCases: {},
      casesList: [],
      totalCases: 0,
      casesDetail: [],
      caseDetail: {},
      pageCount: 1,
      sortFlag: 'ASC',
      orderFlags: false,
      pageFlag: true,
    };
    this.zeroProductSubmitModal = null;

    // Ref to the bottom of the list
    this.bottomRef = React.createRef();
  }

  componentDidMount() {
    try {
      this.zeroProductSubmitModal = new window.bootstrap.Modal(window.$('#zeroProductSubmitModal'));
      window.addEventListener('scroll', this.handleScroll);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  componentWillUnmount() {
    // window.removeEventListener('scroll', this._onCasesScroll);
    window.removeEventListener('scroll', this.handleScroll);
  }

  _onCasesScroll = () => {
    window.closeAllCasesMenu();
  }

  _onFilter = () => {
    try {
      this.setState(
        (prevState) => ({
          orderFlags: !prevState.orderFlags,
          pageCount: 1,
        }),
        () => {
          // Scroll to the top of the page after sorting
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      );

      // this.setState({ orderFlags: false }, () => {
      //   console.log(this.state.orderFlags, 'orderFlags');
      // });

      setTimeout(() => {
        this._getCaseHistory();
      }, 100);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getCaseHistory = async () => {
    try {
      const { setLoader, notify } = this.props;
      const {
        caseDetail, pageCount, sortFlag, orderFlags
      } = this.state;
      const searchData = {
        sort: (orderFlags ? sortFlag : 'DESC'),
        page: pageCount
      };
      setLoader(true);
      await caseHistory(caseDetail.CaseScheduleID, searchData).then(async (response) => {
        const { status, message } = response;
        if (status) {
          const { data } = response;
          if (typeof data !== 'undefined' && data.length > 0) {
            this.setState({
              casesList: data,
              casesDetail: data,
              totalCases: data.length,
              pageFlag: true
            });
            setLoader(false);
          } else {
            setLoader(false);
            notify({ type: 'error', message: 'No cases history found.' });
          }
        } else {
          setLoader(false);
          notify({ type: 'error', message });
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getCaseHistoryPage = async () => {
    try {
      const { setLoader, notify } = this.props;
      const {
        caseDetail, pageCount, sortFlag, orderFlags
      } = this.state;
      // console.log(this.state);
      const searchData = {
        sort: (orderFlags ? sortFlag : 'DESC'),
        page: pageCount
      };
      // console.log(searchData);
      setLoader(true);
      await caseHistory(caseDetail.CaseScheduleID, searchData).then(async (response) => {
        const { status, message } = response;
        if (status) {
          const { data } = response;
          if (typeof data !== 'undefined' && data.length > 0) {
            this.setState((prevState) => ({
              casesList: [...prevState.casesList, ...data],
              casesDetail: [...prevState.casesDetail, ...data],
              totalCases: data.length,
              pageFlag: true
            }));
            setLoader(false);
          } else {
            this.setState(
              (prevState) => ({
                pageFlag: !prevState.pageFlag
              })
            );
            setLoader(false);
            // notify({ type: 'error', message: 'No cases history found.' });
          }
        } else {
          setLoader(false);
          notify({ type: 'error', message });
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  handleScroll = () => {
    if (
      (window.innerHeight + document.documentElement.scrollTop)
      === document.documentElement.offsetHeight
    ) {
      // this.loadMoreData();
    }
  };

  loadMoreData = () => {
    const { totalCases, pageFlag } = this.state;
    if (totalCases === 10 && pageFlag) {
      this.setState(
        (prevState) => ({ pageCount: prevState.pageCount + 1 })
      );

      // this.setState({ pageCount: pageCount + 1 });
      // await this._getCaseHistoryPage();

      // this.setState({ orderFlags: false }, () => {
      //   console.log(this.state.orderFlags, 'orderFlags');
      // });

      setTimeout(async () => {
        await this._getCaseHistoryPage();
      }, 100);
    }
  };

  _goBack = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getScreenWidth = () => {
    this.setState({ screenWidth: window.screen.width });
  }

  _getById = async () => {
    try {
      const {
        params: { id }, tableName
      } = this.props;
      const caseRes = await getTableCaseByCaseId(id, tableName);
      this.setState({ caseDetail: caseRes });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        online, notify
      } = this.props;
      // console.log(this.props);
      await this._getScreenWidth();
      await this._getById();

      if (online) {
        await this._getCaseHistory();
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.'
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      casesList, caseDetail, orderFlags,
      // screenWidth,
      casesDetail, totalCases, pageFlag
    } = this.state;

    return (
      <div className="site-wrapper resizer-class">
        <Header
          title="Case History"
          goBack={this._goBack}
          actionCaseHisterButton={{ onClick: this._onFilter, orderFlag: orderFlags }}
        />
        <section className={`cards-section pt-0 ${(casesList.length > 0) ? 'resizer-class' : ''}`}>
          <div className="container">
            <div className="row case-history">
              {
                casesDetail.map((crtCase, key) => (
                  <div className={key === 0 ? 'pb-2 pt-2' : 'pb-2'} key={key}>
                    <div className="list" key={key}>
                      <LazyLoad
                        height={80}
                        continuous
                        once
                      >
                        <div className="col-12 col-md-12 cursor-pointer">
                          <table>
                            <tbody>
                              <tr>
                                <td>Date</td>
                                <td>{moment(crtCase.EventDate).format('MM/DD/YYYY h:mm A')}</td>
                              </tr>
                              <tr>
                                <td>Event</td>
                                <td>{crtCase.EventDescription}</td>
                              </tr>
                              <tr>
                                <td>Value</td>
                                <td className="truncate">
                                  {crtCase.EventValue !== null ? (crtCase.EventValue !== '' ? crtCase.EventValue : 'Null') : 'Null'}
                                </td>
                              </tr>
                              <tr>
                                <td>User</td>
                                <td>{crtCase.Username}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </LazyLoad>
                    </div>
                  </div>
                ))
              }

              <div className="col text-center mb-10">
                <button
                  type="button"
                  className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${totalCases === 10 && pageFlag ? '' : 'd-none'}`}
                  onClick={() => this.loadMoreData()}
                >
                  Show More
                </button>
              </div>
              <ZeroProductSubmitModal
                onSubmitProductCaseYes={this._onSubmitProductCaseYes}
                onSubmitProductCaseNo={this._onSubmitProductCaseNo}
                caseDetail={caseDetail}
              />
              <div ref={this.bottomRef} />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withTableName(
  withUser(
    withOnline(
      withNotify(
        withLoader(
          withGoBack(
            withTeam(
              CaseHistory
            )
          )
        )
      )
    )
  )
);
